<template>
  <div class="relevant-list" id="relevant" v-loading="loading" :element-loading-text="loadintText">
    <chatCard v-for="(item) in list" :key="item.id" :item="item" />
  </div>
</template>

<script>
import chatCard from "@/components/ChatCard.vue";
import { CHAT_API_DATA } from "@/api/chat";
export default {
  name: "relevant",
  components: {
    chatCard,
  },
  data() {
    return {
      page: 1,
      scroll: "",
      oldScroll: "",
      loading: false,
      loadintText: "数据加载中...",
      list: [],
    };
  },
  created() {
    this.getMyMessageList();
  },
  mounted() {
    this.$el.addEventListener("scroll", this.onScroll);
  },
  methods: {
    //监听滚动
    onScroll() {
      this.scroll = this.$el.scrollTop;
      if (this.scroll === 0) {
        this.page++;
        this.getMyMessageList();
      }
    },
    //获取聊天记录
    getMyMessageList() {
      const data = {
        page: this.page,
        limit: 10,
      };
      this.loading = true;
      CHAT_API_DATA.getMyMessageList(data)
        .then((res) => {
          this.loading = false;
          this.list = [...res.rows.reverse(), ...this.list];
          this.userUnRead();
        })
        .catch((err) => {
          this.$message({
            showClose: true,
            message: "连接超时，请重试！",
            type: "warning",
          });
          console.log(err);
        });
    },
    userUnRead() {
      CHAT_API_DATA.userUnRead()
        .then((res) => {
          this.$emit("userUnRead", res.data);
        })
        .catch((err) => {
          this.showErr(err);
        });
    },
  },
  watch: {
    //监听list数据置底
    list: {
      handler() {
        this.$nextTick(() => {
          let contant = this.$el;
          if (this.page === 1) {
            this.oldScroll = contant.scrollHeight;
            contant.scrollTop = contant.scrollHeight;
            console.log(this.oldScroll);
          } else {
            contant.scrollTop = contant.scrollHeight - this.oldScroll;
            this.oldScroll = contant.scrollHeight;
            console.log(this.oldScroll);
          }
        });
      },
    },
  },
};
</script>

<style scoped>
.relevant-list {
  margin-top: 20px;
  min-height: 500px;
  max-height: 500px;
  overflow: hidden;
  overflow-y: scroll;
  /* background-color: #f0f5fa; */
}
.relevant-list::-webkit-scrollbar {
  display: none;
}
</style>